import styled from 'styled-components';
import ds from 'designsystem';

const DesktopNavTitle = styled.h1`
  font-size: ${ds.fontSize('base')};
  font-family: ${ds.get('type.fontFamily.text')};
  color: ${ds.brand('regular')};
  padding: 0 ${ds.get('metrics.s')};
  font-weight: ${ds.get('type.fontWeight.bold')};
`;

export default DesktopNavTitle;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/DesktopNavigation/DesktopNavTitle.jsx